import React from 'react';
import type { StoreContactDto } from '../../../../services/checkoutConfig/checkoutConfig.types';

interface ContactInformationSectionProps {
  contact: StoreContactDto;
  email?: string;
  showWhatsapp: boolean;
  showPhone: boolean;
  textColor: string;
}

export const ContactInformationSection: React.FC<ContactInformationSectionProps> = ({
  contact,
  email,
  showWhatsapp,
  showPhone,
  textColor,
}) => {
  const whatsapp = showWhatsapp ? contact.whatsapp : null;
  const phone = showPhone ? contact.phone : null;

  if (!whatsapp && !phone && !email) return null;

  return (
    <div className="mb-4" style={{ color: textColor }}>
      <div className="text-xs">
        {(whatsapp || phone) && (
          <div className="mb-2">
            {whatsapp && <>WhatsApp: {whatsapp}</>}
            {whatsapp && phone && ' / '}
            {phone && <>Telefone: {phone}</>}
          </div>
        )}
        {email && <div>E-mail: {email}</div>}
      </div>
    </div>
  );
};
